import axios from "axios";
import { ElMessage } from 'element-plus'

// 登录
export async function loginFun(params) {
    return new Promise((resolve, reject) => {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
        axios.post("/api/bms/auth/login", params).then((res) => {
            if (res.data.code == "200") {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: '登录成功！',
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 退出登录
export async function logOutFun() {
    return new Promise((resolve, reject) => {
        axios.post("/api/bms/auth/logout").then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}